export default [
  {
    path: "/user",
    name: "Lilly User",
    meta: { title: "Lilly-User" },
    component: () => import("../views/lilly_user/user.vue")
  },
]